
















































































import { Route, ServiceRequest } from '@/types/entity';
import { DateUtils } from '@/util/dateUtils';
import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/Modal.scss';
import { ObjectFactory } from '../../config/objectFactory';
import { MedTransGoConstants } from '../../util/constants';
import GoogleMap from '../../components/GoogleMap.vue';
import ConfirmationBox from '../../components/ConfirmationBox.vue';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { CommonUtils } from '@/util/commonUtils';
import PartnerConfirmationModal from '../modal/PartnerConfirmationModal.vue';

@Component({
    props: {
        id: String,
    },
    data() {
        return {
            routeIds: [],
        };
    },
    components: {
        GoogleMap,
        ConfirmationBox,
        PartnerConfirmationModal,
    },
})
export default class AcceptRequestModal extends Vue {
    private show = true;
    private showConfirmBox = false;
    private serviceRequest: ServiceRequest | any = '';
    private DateUtils = DateUtils;
    private disableSubmit = true;
    private mapRoutes: Route[] = [];
    private showPartnerConfirmed = false;
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private transporterId = '';

    public async mounted() {
        this.getRequestDetails();
        if (this.sessionInfo.scopes.includes('dispatcher')) {
            const partnerService = ObjectFactory.getPartnerService();
            const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
            if (response.success && response.data) {
                if (response.data.dispatcherProfile && response.data.dispatcherProfile.transporterId) {
                    this.transporterId = response.data.dispatcherProfile.transporterId;
                }
            }
        } else {
            this.transporterId =  this.$props.id || this.$route.params.id;
        }
    }
    private async getRequestDetails() {
        const id = this.$props.id || this.$route.params.id;
        this.mapRoutes = [];
        const response = await ObjectFactory.getRequestService().getRequestDetails(id, this.$store.state.serverUrl);
        this.serviceRequest = response.data;
        if (this.serviceRequest.deliveryRequest) {
            this.mapRoutes = this.serviceRequest.deliveryRequest.mapRoutes;
        }
        if (response.data && response.data.transportRequest) {
            this.mapRoutes = this.serviceRequest.transportRequest.mapRoutes;
        }
    }

    private setRouteId(routeId?: any) {
        const index = this.$data.routeIds.indexOf(routeId);
        if (!index || index !== -1) {
            this.$data.routeIds.splice(index, 1);
        } else {
            this.$data.routeIds.push(routeId);
        }
        if (this.$data.routeIds.length >= 1) {
            this.disableSubmit = false;
        } else {
            this.disableSubmit = true;
        }
    }

    private async acceptRequest() {
        let response: any;
        const id = this.$props.id || this.$route.params.id;
        response = await ObjectFactory.getRequestService().acceptRequest(id,
            this.$store.state.serverUrl, {
                routes: this.$data.routeIds,
            });
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Request Accepted Successfully',
                title: 'Request Accepted!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            await this.getRequestDetails();
            if (this.serviceRequest.status === 'Confirmed') {
                this.$router.push({
                    path: `${MedTransGoConstants.URL_REQUESTS}/${id}`,
                    query: { requestType: this.serviceRequest.deliveryRequest ? 'deliveryRequest' :
                    'transportRequest', status: 'Confirmed' },
                });
                this.close();
            } else {
                this.close();
            }
        } else {
            CommonUtils.showError(response);
            this.showConfirmBox = false;
        }
    }

    private gotoRequests(id?: string) {
        if (id) {
            this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}/${id}` });
        } else {
            this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}` });
        }
    }

    private async showPartnerConfirm() {
        if (this.serviceRequest.transportRequest) {
            this.showPartnerConfirmed = true;
        } else {
            this.acceptRequest();
        }
    }

    private close() {
        this.$emit('close');
    }

}
